import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as projectActions from '../../../../redux/projects/actions.projects';
import * as unloadPageActions from '../../../../redux/unloadPage/actions.unloadPage';
import * as analyticsActions from '../../../../redux/analytics/actions.analytics';
import PromoCodeForm from './PromoCodeForm/PromoCodeForm';
import BillingStripeWrapper from '../BillingStripeWrapper';
import BillingViewLoader from '../BillingViewLoader/BillingViewLoader';
import menuItems from '../../../../const/menuItems';
import cancelEvent from '../../../../services/mini/cancelEvent';
import PayPalForm from './PayPalForm/PayPalForm';
import GaService from '../../../../services/GaService';
import billingEvents from '../../../../const/billingEvents';
import { BILLING_STRIPE, BILLING_PROMOCODE, BILLING_PAYPAL, BILLING_STRIPE_SAVED_CARD } from '../../../../const/billingTypes';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import { importExternalScript } from '../../../../services/ExternalScriptImporter';
import { reachMetrikaGoal } from '../../../../services/MetrikaService';
import { Loader } from '../../../components/Loader/Loader';
import BillingFormHolder from './BillingFormHolder/BillingFormHolder';
import PromoCodeFormHeader from './PromoCodeForm/PromoCodeFormHeader';
import PayPalFormHeader from './PayPalForm/PayPalFormHeader';
import StripeFormHeader from './StripeForm/StripeFormHeader';
import SavedCreditCardsForm from './SavedCreditCardsForm/SavedCreditCardsForm';
import StripeForm from './StripeForm/StripeForm';
import store from '../../../../store';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import { isAnyPaymentAvailable, isPaypalPaymentAvailable, isStripePaymentAvailable, getStripeScriptLocation, getPaypalScriptLocation } from '../../../../utils/env/billingEnv';


const PROMO_CODE = 'promo-code';
const CREDIT_CARD = 'credit-card';
const PAYPAL = 'paypal';
const SAVED_CARDS = 'saved-cards';


//todo: REFACTOR IT
class BillingForms extends React.Component {
    constructor(props, context) {
        super(props, context);

        const {
            expandCardsSection,
            expandStripeSection,
            expandPromoCodeSection
        } = props;

        let openedForm = null;

        if (expandCardsSection) {
            openedForm = SAVED_CARDS;
        } else if (expandPromoCodeSection) {
            openedForm = PROMO_CODE;
        } else if (expandStripeSection) {
            openedForm = CREDIT_CARD;
        }

        this.state = {
            openedForm,
            isPayPalLoaded: false,
            isStripeLoaded: false,
            paypalHeight: 100,
        };

        this._mounted = false;
    }

    componentDidMount() {
        const {
            trackPaymentError,
            isInitialBilling,
            trackPaymentStart
        } = this.props;

        this._mounted = true;

        trackPaymentStart({
            paymentMethod: "-",
            paymentStatus: billingEvents.seeBillingView,
            ...this.getContextInfo(),
        });

        if (isPaypalPaymentAvailable(this.props.features)) {
            importExternalScript(getPaypalScriptLocation())
                .then(() => {
                    this.setState({ isPayPalLoaded: true });
                })
                .catch(() => {
                    if (this._mounted) {
                        trackPaymentError({
                            paymentMethod: BILLING_PAYPAL,
                            isInitialBilling: isInitialBilling,
                            paymentStatus: billingEvents.paypalIsUnavailable
                        });
                    }
                });
        }
        if (isStripePaymentAvailable(this.props.features)) {
            importExternalScript(getStripeScriptLocation())
                .then(() => {
                    if (this._mounted) {
                        this.setState({ isStripeLoaded: true });
                    }
                })
                .catch(() => {
                    if (this._mounted) {
                        trackPaymentError({
                            paymentMethod: BILLING_STRIPE,
                            isInitialBilling: isInitialBilling,
                            paymentStatus: billingEvents.stripeIsUnavailable
                        });
                    }
                });
        }
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    toggleCreditForm = () => {
        const { openedForm } = this.state;
        const { trackPaymentStart } = this.props;
        if (openedForm !== CREDIT_CARD) {
            this.setState({ openedForm: CREDIT_CARD });
            reachMetrikaGoal('showCreditCardForm');
            trackPaymentStart({
                paymentMethod: BILLING_STRIPE,
                paymentStatus: billingEvents.openForm,
                ...this.getContextInfo(),
            });
        }
    }

    togglePromoCodeForm = () => {
        const { openedForm } = this.state;
        const { trackPaymentStart } = this.props;
        if (openedForm !== PROMO_CODE) {
            this.setState({ openedForm: PROMO_CODE });
            reachMetrikaGoal('showPromoForm');
            trackPaymentStart({
                paymentMethod: BILLING_PROMOCODE,
                paymentStatus: billingEvents.openForm,
                ...this.getContextInfo(),
            });
        }
    }

    togglePayPalForm = () => {
        const { openedForm } = this.state;
        const { trackPaymentStart } = this.props;
        if (openedForm !== PAYPAL) {
            this.setState({ openedForm: PAYPAL });
            reachMetrikaGoal('showPayPalForm');
            trackPaymentStart({
                paymentMethod: BILLING_PAYPAL,
                paymentStatus: billingEvents.openForm,
                ...this.getContextInfo(),
            });
        }
    }

    toggleSavedCreditCardForm = () => {
        const { openedForm } = this.state;
        const { trackPaymentStart } = this.props;
        if (openedForm !== SAVED_CARDS) {
            this.setState({ openedForm: SAVED_CARDS });
            reachMetrikaGoal('showSavedCreditCardsForm');
            trackPaymentStart({
                paymentMethod: BILLING_STRIPE_SAVED_CARD,
                paymentStatus: billingEvents.openForm,
                ...this.getContextInfo(),
            });
        }
    }

    setPayPalHeight = (height) => {
        this.setState({ paypalHeight: height + 180 });
    }

    closeForm = () => {
        reachMetrikaGoal('closeBillingForm');
        this.setState({ openedForm: null });
    };

    clickInsideForm = (e) => {
        cancelEvent(e);
    }

    trackContactUs = () => {
        GaService.sendContactUsPageView();
    }

    onBillingFinished = (paymentId) => {
        const {
            updateUnloadPageListenerForBilling,
            nextPlan,
            onBillingFinishedCb,
            refund
        } = this.props;

        if (updateUnloadPageListenerForBilling) {
            updateUnloadPageListenerForBilling({ hasListener: false });
        }

        if (nextPlan?.isEnterprise || nextPlan?.isPeriodic) {
            if (onBillingFinishedCb) {
                onBillingFinishedCb(paymentId, 'stripe');
            }
        } else {
            this.setState({ payingIsInProcess: false });
            if (refund && onBillingFinishedCb) {
                onBillingFinishedCb();
                return;
            }
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <ConfirmPopup
                            onClose={() => {
                                onClose();
                                if (onBillingFinishedCb) {
                                    onBillingFinishedCb(paymentId, 'stripe');
                                }
                            }}
                            hideCancelBtn={true}
                            okBtnCb={() => {
                                onClose();
                                if (onBillingFinishedCb) {
                                    onBillingFinishedCb(paymentId, 'stripe');
                                }
                            }}
                            type="success"
                            title="Balance changed"
                            message={<React.Fragment>Your account has been replenished successfully. <br />
                                <b>Now your balance is ${Number(this.props.balance).toFixed(2)}.</b>
                            </React.Fragment>}
                        />
                    );
                }
            });
        }
    }

    render() {
        const {
            applyPromoCode,
            balance,
            freeInteractions,
            hasPaymentInfo,
            updateUnloadPageListenerForBilling,
            createPaypalOrder,
            checkIsPaypalOrderApproved,
            onBillingFinishedCb,
            amount,
            nextPlan,
            hideCardsBtn,
            hideStripeBtn,
            hidePaypalBtn,
            hidePromoCodeBtn,
            stripeFormTitle,
            stripeBtnTitle,
            refund,
            campaignName
        } = this.props;

        const {
            openedForm,
            paypalHeight,
            isPayPalLoaded,
            isStripeLoaded,
        } = this.state;

        const readOnlyAmount = nextPlan?.isPeriodic || this.props.readOnlyAmount;
        const isOneBtnAvailable = [
            hideCardsBtn,
            hideStripeBtn,
            hidePaypalBtn,
            hidePromoCodeBtn
        ].filter(val => val).length === 2;

        return (
            hasPaymentInfo ?
                <div className="billing-forms">
                    {/* <BillingFormHolder
                        isVisible={!hideCardsBtn}
                        isOpened={openedForm === SAVED_CARDS}
                        canBeClosed={!isOneBtnAvailable}
                        onClick={this.toggleSavedCreditCardForm}
                        onClose={this.closeForm}
                        openedFormHeight={342}
                        header={<StripeFormHeader title="Select card for payment" />}
                        form={
                            isStripeLoaded ?
                                <BillingStripeWrapper>
                                    <SavedCreditCardsForm
                                        store={store}
                                        nextPlan={nextPlan}
                                        readOnlyAmount={readOnlyAmount}
                                        amount={amount}
                                        onBillingFinishedCb={this.onBillingFinished}
                                    />
                                </BillingStripeWrapper> :
                                <Loader theme="dark" size="small" />
                        } /> */}

                    <BillingFormHolder
                        isVisible={isStripePaymentAvailable(this.props.features) && !hideStripeBtn}
                        isOpened={openedForm === CREDIT_CARD}
                        canBeClosed={!isOneBtnAvailable}
                        onClick={this.toggleCreditForm}
                        onClose={this.closeForm}
                        openedFormHeight={562}
                        header={<StripeFormHeader title={stripeFormTitle} />}
                        form={
                            isStripeLoaded ?
                                <BillingStripeWrapper>
                                    <StripeForm
                                        store={store}
                                        nextPlan={nextPlan}
                                        readOnlyAmount={readOnlyAmount}
                                        amount={amount}
                                        infoMsg={this.props.infoMsg}
                                        refund={refund}
                                        onBillingFinishedCb={this.onBillingFinished}
                                        stripeBtnTitle={stripeBtnTitle} />
                                </BillingStripeWrapper> :
                                <Loader theme="dark" size="small" />
                        } />

                    <BillingFormHolder
                        isVisible={isPaypalPaymentAvailable(this.props.features) && !hidePaypalBtn}
                        isOpened={openedForm === PAYPAL}
                        canBeClosed={!isOneBtnAvailable}
                        onClick={this.togglePayPalForm}
                        onClose={this.closeForm}
                        openedFormHeight={paypalHeight}
                        header={<PayPalFormHeader />}
                        form={
                            isPayPalLoaded ?
                                <PayPalForm
                                    onBillingFinishedCb={onBillingFinishedCb}
                                    createPaypalOrder={createPaypalOrder}
                                    checkIsPaypalOrderApproved={checkIsPaypalOrderApproved}
                                    updateUnloadPageListenerForBilling={updateUnloadPageListenerForBilling}
                                    balance={balance}
                                    amount={amount}
                                    campaignName={campaignName}
                                    onRendered={this.setPayPalHeight} /> :
                                <Loader theme="dark" size="small" />
                        } />

                    <BillingFormHolder
                        isVisible={!hidePromoCodeBtn}
                        isOpened={openedForm === PROMO_CODE}
                        canBeClosed={!isOneBtnAvailable}
                        onClick={this.togglePromoCodeForm}
                        onClose={this.closeForm}
                        openedFormHeight={220}
                        header={<PromoCodeFormHeader />}
                        form={
                            <PromoCodeForm
                                onBillingFinishedCb={onBillingFinishedCb}
                                applyPromoCode={applyPromoCode}
                                updateUnloadPageListenerForBilling={updateUnloadPageListenerForBilling}
                                freeInteractions={freeInteractions}
                                campaignName={campaignName} />
                        } />

                    {(!isAnyPaymentAvailable(this.props.features) && hidePromoCodeBtn) && <div className="billing-forms_terms">

                        No payment methods available.<br />Please contact <a href="mailto:support@alan.app"
                            target="_blank" rel="noreferrer">
                            support
                        </a> for additional details.
                    </div>}
                    {isAnyPaymentAvailable(this.props.features) &&
                        <div className="billing-forms_terms">
                            By continuing, you agree to all Alan AI Terms and Conditions, which include  <b>
                                <a target="_blank" rel="noreferrer"
                                    href={`${menuItems.privacyPolicy.href}`}>Privacy&nbsp;Policy</a>
                                &nbsp;&&nbsp;
                                <a target="_blank" rel="noreferrer"
                                    href={`${menuItems.termsOfService.href}`}>Terms of Service</a>
                            </b>
                        </div>}
                </div> : <BillingViewLoader />
        );
    }

    getContextInfo() {
        const {
            isInitialBilling,
        } = this.props;

        return {
            isInitialBilling,
        };
    }

    getChildContext() {
        const {
            trackPaymentStart,
            trackPaymentError,
            trackPaymentSuccess,
        } = this.props;

        return {
            trackPaymentStart,
            trackPaymentError,
            trackPaymentSuccess,
            ...this.getContextInfo()
        };
    }

}

BillingForms.childContextTypes = {
    trackPaymentStart: PropTypes.func,
    trackPaymentError: PropTypes.func,
    trackPaymentSuccess: PropTypes.func,
    isInitialBilling: PropTypes.bool,
    contentId: PropTypes.string,
};

function mapStateToProps({ user, config }, ownProps) {
    return {
        balance: user.balance,
        campaignName: user.campaignName,
        isEnterprise: user.isEnterprise,
        freeInteractions: user.freeInteractions,
        hasAssignedCard: user.hasAssignedCard,
        hasPaymentInfo: user.hasPaymentInfo,
        features: config?.features
    };
}

function mapDispatchToProps(dispatch) {
    return {
        sendBillingToken: (param) => asyncDispatch(projectActions.sendBillingToken, dispatch, param),
        getStripePaymentIntent: (param) => asyncDispatch(projectActions.getStripePaymentIntent, dispatch, param),
        proceedStripePayment: (param) => asyncDispatch(projectActions.proceedStripePayment, dispatch, param),
        applyPromoCode: (param) => asyncDispatch(projectActions.applyPromoCode, dispatch, param),
        createPaypalOrder: (param) => asyncDispatch(projectActions.createPaypalOrder, dispatch, param),
        checkIsPaypalOrderApproved: (param) => asyncDispatch(projectActions.checkIsPaypalOrderApproved, dispatch, param),
        updateUnloadPageListenerForBilling: (param) => dispatch(unloadPageActions.updateUnloadPageListenerForBilling(param)),
        trackPaymentStart: (param) => dispatch(analyticsActions.trackPaymentStart(param)),
        trackPaymentError: (param) => dispatch(analyticsActions.trackPaymentError(param)),
        trackPaymentSuccess: (param) => dispatch(analyticsActions.trackPaymentSuccess(param)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingForms);
